module.exports = __webpack_public_path__ + "static/media/emergency.ef7e3f9e.jpg";